import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const CompareQuotesStyle = styled('div')`
    line-height: 1.2;
    .box-header {
        background: var(--orange-300);
        color: var(--sand-100);
        ${typography.subhead}
        min-height: 60px;
        display: flex;
        align-items: center;
        padding: 0;
        .container-ydp {
            width: 100%;
        }
        .icon-close {
            font-size: 24px;
            cursor: pointer;
        }
    }

    .ant-spin-dot-item {
        background: var(--white);
    }

    .content-compare {
        margin-top: 20px;
        .item-compare {
            max-width: 329px;
            width: 100%;
            font-size: 14px;
            .num {
                ${typography.tertiary}
                font-size: 16px;
                letter-spacing: -0.02em;
                color: var(--orange-300);
                margin-bottom: 16px;
            }
            .title {
                ${typography.bodyL}
                padding: 8px 16px;
                color: var(--sand-100);
                background: var(--orange-300);
                span {
                    height: 48px;
                    line-height: 24px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
            .item-content {
                color: var(--sand-700);
            }
            .main-image {
                border-radius: 6px 6px 0 0;
                overflow: hidden;
                position: relative;
                vertical-align: middle;
                &::before {
                    display: block;
                    content: '';
                    width: 100%;
                    padding-top: 58%;
                }
                img {
                    right: 0;
                    width: 100%;
                    height: 100%;
                    bottom: 0;
                    left: 0;
                    top: 0;
                    position: absolute;
                    object-fit: cover;
                    border-radius: 6px 6px 0 0;
                }
            }
            .reference {
                ${typography.bodySm}
                color: var(--sand-700);
                background: var(--sand-300);
                text-align: center;
                padding: 8px 0;
            }
            .box-detail {
                padding: 16px 16px 10px;
                overflow-y: auto;
                height: calc(100vh - 430px);
                background: var(--white);
                border-radius: 0 0 6px 6px;
                .item {
                    ${typography.bodyXs}
                    color: var(--sand-600);
                    display: flex;
                    align-items: baseline;
                    gap: 6px;
                    padding: 4px 0;

                    .icon-detail {
                        width: 18px;
                        font-size: 16px;
                        position: relative;
                        top: 2px;
                        color: var(--orange-300);
                    }

                    .title-detail {
                        width: 90%;
                    }
                }
                .total-price {
                    ${typography.bodyL}
                }

                .price {
                    ${typography.bodySm}
                    margin: 12px 0 4px;
                }
            }
        }
    }

    .box-carousel {
        position: relative;

        .icon-circle {
            cursor: pointer;
            position: absolute;
            top: 218px;
            font-size: 30px;
            border-radius: 50%;
            color: var(--orange-300);
            background: var(--white);
            border: 1px solid var(--white);
            z-index: 1;
            &.btn-prev {
                left: -5px;
            }
            &.btn-next {
                right: -5px;
            }
        }
    }

    .ant-skeleton {
        width: 100%;
    }

    ${media.mobile} {
        .box-header {
            min-height: 50px;
            padding: 10px 0;
        }
        .content-compare {
            .item-compare {
                margin: auto;
            }
        }
    }

    @media screen and (max-height: 600px) {
        .content-compare {
            .item-compare {
                max-height: calc(100vh - 85px);
                overflow-y: auto;

                .box-detail {
                    overflow-y: unset;
                    height: auto;
                }
            }
        }
    }
`;

export default CompareQuotesStyle;
